<template>
  <div>
    <!-- Row 0: Filter -->
    <div class="row">
      <div class="col-xl-12">
        <div class="kt-portlet">
          <div class="kt-portlet__body">
            <div class="row">
              <div class="col-xl-3 col-lg-3">
                <div class="form-group">
                  <label>ปี :</label>
                  <div class="input-group date">
                    <input type="text" class="form-control" placeholder="(YYYY)" ref="odYear" autocomplete="off" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3">
                <div class="form-group">
                  <label>เดือน :</label>
                  <select class="form-control" v-model="selectedMonth">
                    <option v-for="(m, idx) in monthsTH_Full" :key="idx" :value="idx + 1">{{ m }}</option>
                  </select>
                </div>
              </div>
              <div class="col-xl-5 col-lg-5">
                <div class="form-group">
                  <label>ชื่อตัวแทนจำหน่าย :</label>
                  <treeselect
                    v-model="selectedAgents"
                    :multiple="true"
                    :options="agentOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือกตัวแทน"
                  />
                </div>
              </div>
              <div class="col-xl-1 col-lg-1 d-flex align-items-end">
                <div class="form-group">
                  <button type="button" class="btn btn-secondary" @click="clearSelectedAgents">ล้างข้อมูล</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Agent Charts: 1 ชุดกราฟ per agent -->
    <template v-for="(agent, agentIdx) in chartAgents">
      <!-- Agent Header -->
      <div class="row" :key="'header-'+agentIdx">
        <div class="col-xl-12">
          <div class="d-flex justify-content-between align-items-center mb-3 px-1">
            <h5 class="mb-0">{{ getAgentLabel(agent) }}</h5>
            <span class="text-muted">ข้อมูล ณ เดือน : {{ displayThaiMonth }}</span>
          </div>
        </div>
      </div>

      <!-- Charts Row -->
      <div class="row" :key="'charts-'+agentIdx">
        <!-- กราฟถัง (ซ้าย) -->
        <div class="col-xl-6">
          <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg">
              <div class="kt-portlet__head-label">
                <span class="kt-portlet__head-icon">
                  <i class="flaticon-truck kt-font-success"></i>
                </span>
                <h3 class="kt-portlet__head-title"> คะแนนถังคงค้าง
                  <span class="info-hint" data-tooltip="กรณีเป็นสำนักงานใหญ่ (คะแนนนี้คำนวณจากสาขาที่ได้คะแนนน้อยที่สุด)">i</span>
                </h3>
              </div>
            </div>
            <div class="kt-portlet__body">
              <div class="row">
                <div class="col-9">
                  <canvas :id="'kegChart-'+agentIdx"></canvas>
                </div>
                <div class="col-3 d-flex flex-column align-items-center justify-content-center">
                  <div class="score-box" :class="getScoreBoxValue(agent, 'MAC') >= 40 ? 'score-box--green' : 'score-box--red'">
                    <span class="score-value" :style="{ color: getScoreBoxValue(agent, 'MAC') >= 40 ? '#0abb87' : '#fd397a' }">{{ getScoreBoxValue(agent, 'MAC') }}</span>
                  </div>
                  <small class="text-muted mt-2">คะแนนเต็ม 40</small>
                </div>
              </div>
              <!-- Score Table -->
              <div class="table-responsive mt-3">
                <table class="table table-sm table-borderless text-center mb-0">
                  <tr>
                    <td class="text-left font-weight-bold" style="white-space:nowrap;">คะแนน</td>
                    <td v-for="(score, idx) in getAgentScores(agent, 'MAC')" :key="'ks'+agentIdx+'-'+idx"
                        :style="{ color: score === null ? 'inherit' : (score >= 40 ? '#0abb87' : '#fd397a'), fontWeight: 'bold' }">
                      {{ score !== null ? score : '-' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left font-weight-bold" style="white-space:nowrap;">เดือน</td>
                    <td v-for="(m, idx) in monthsEN" :key="'km'+agentIdx+'-'+idx"
                        :style="{ color: getAgentScores(agent, 'MAC')[idx] === null ? 'inherit' : (getAgentScores(agent, 'MAC')[idx] >= 40 ? '#0abb87' : '#fd397a'), fontWeight: getAgentScores(agent, 'MAC')[idx] !== null ? 'bold' : 'normal' }">{{ m }}</td>
                  </tr>
                  <tr v-if="hasRemarks(agent, 'MAC')">
                    <td class="text-left font-weight-bold" style="white-space:nowrap;">หมายเหตุ</td>
                    <td v-for="(remark, idx) in getAgentRemarks(agent, 'MAC')" :key="'mkr'+agentIdx+'-'+idx">
                      <a href="javascript:void(0)" v-if="remark"
                         @click="openRemarkModal(agent, 'MAC', idx)" class="text-primary" style="cursor:pointer;" title="อ่านหมายเหตุ">
                        <i class="la la-comment"></i>
                      </a>
                      <span v-else class="text-muted">-</span>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- Link -->
              <div class="mt-2">
                <a href="/Report/KegRotationScoreAgent" target="_blank" class="text-primary">
                  <i class="la la-link"></i> Link : รายงานคะแนนถังคงค้าง(ตัวแทนจำหน่าย)
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- กราฟบันทึก (ขวา) -->
        <div class="col-xl-6">
          <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg">
              <div class="kt-portlet__head-label">
                <span class="kt-portlet__head-icon">
                  <i class="flaticon-graph kt-font-brand"></i>
                </span>
                <h3 class="kt-portlet__head-title">คะแนนการทำระบบเบียร์สด
                  <span class="info-hint" data-tooltip="แสดงคะแนนแยกตามรายสาขาตามจริง (ไม่มีการคำนวณจากสาขาที่ได้คะแนนน้อยที่สุด)">i</span>
                </h3>
              </div>
            </div>
            <div class="kt-portlet__body">
              <div class="row">
                <div class="col-9">
                  <canvas :id="'recordingChart-'+agentIdx"></canvas>
                </div>
                <div class="col-3 d-flex flex-column align-items-center justify-content-center">
                  <div class="score-box" :class="getScoreBoxValue(agent, 'SYS') >= 40 ? 'score-box--green' : 'score-box--red'">
                    <span class="score-value" :style="{ color: getScoreBoxValue(agent, 'SYS') >= 40 ? '#0abb87' : '#fd397a' }">{{ getScoreBoxValue(agent, 'SYS') }}</span>
                  </div>
                  <small class="text-muted mt-2">คะแนนเต็ม 40</small>
                </div>
              </div>
              <!-- Score Table -->
              <div class="table-responsive mt-3">
                <table class="table table-sm table-borderless text-center mb-0">
                  <tr>
                    <td class="text-left font-weight-bold" style="white-space:nowrap;">คะแนน</td>
                    <td v-for="(score, idx) in getAgentScores(agent, 'SYS')" :key="'rs'+agentIdx+'-'+idx"
                        :style="{ color: score === null ? 'inherit' : (score >= 40 ? '#0abb87' : '#fd397a'), fontWeight: 'bold' }">
                      {{ score !== null ? score : '-' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left font-weight-bold" style="white-space:nowrap;">เดือน</td>
                    <td v-for="(m, idx) in monthsEN" :key="'rm'+agentIdx+'-'+idx"
                        :style="{ color: getAgentScores(agent, 'SYS')[idx] === null ? 'inherit' : (getAgentScores(agent, 'SYS')[idx] >= 40 ? '#0abb87' : '#fd397a'), fontWeight: getAgentScores(agent, 'SYS')[idx] !== null ? 'bold' : 'normal' }">{{ m }}</td>
                  </tr>
                  <tr v-if="hasRemarks(agent, 'SYS')">
                    <td class="text-left font-weight-bold" style="white-space:nowrap;">หมายเหตุ</td>
                    <td v-for="(remark, idx) in getAgentRemarks(agent, 'SYS')" :key="'skr'+agentIdx+'-'+idx">
                      <a href="javascript:void(0)" v-if="remark"
                         @click="openRemarkModal(agent, 'SYS', idx)" class="text-primary" style="cursor:pointer;" title="อ่านหมายเหตุ">
                        <i class="la la-comment"></i>
                      </a>
                      <span v-else class="text-muted">-</span>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- Link -->
              <div class="mt-2">
                <a href="/Report/JobAgentScore" target="_blank" class="text-primary">
                  <i class="la la-link"></i> Link : รายงานคะแนนการทำระบบเบียร์สด
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Remark Modal -->
    <div class="modal fade" id="remarkModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">หมายเหตุ — {{ remarkModal.monthName }}</h5>
            <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <p style="white-space: pre-wrap;">{{ remarkModal.text || '-' }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: { Treeselect },
  data: function () {
    var now = new Date();
    return {
      // Permission
      isSuperAdmin: false,

      // Filter
      selectedAgents: null,
      agentOptions: [],
      selectedYear: now.getFullYear(),
      selectedMonth: now.getMonth() + 1,

      // All agents data from API
      dashboardData: [],

      monthsTH: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
      monthsTH_Full: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
      monthsEN: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],

      // Chart instances
      chartInstances: [],

      // Remark modal
      remarkModal: { monthName: "", text: "" },
    };
  },
  computed: {
    chartAgents: function () {
      if (this.dashboardData.length === 0) {
        return [{ agentCode: "", agentName: "", _empty: true }];
      }
      return this.dashboardData;
    },
    displayThaiMonth: function () {
      return this.monthsTH_Full[this.selectedMonth - 1] + " " + this.selectedYear;
    },
  },
  watch: {
    selectedAgents: function () {
      this.loadDashboardData();
    },
    selectedYear: function () {
      this.loadDashboardData();
    },
    selectedMonth: function () {
      this.$nextTick(function () { this.renderCharts(); }.bind(this));
    },
  },
  methods: {
    checkPermission() {
      this.isSuperAdmin = this.$root.canShow(["super_admin"]);
    },

    clearSelectedAgents() {
      this.selectedAgents = null;
    },

    async loadAgentOptions() {
      try {
        var res = await axios.post("/Api/AgentScore/AgentScoreDashboardAgentList", {});
        if (res.data && Array.isArray(res.data)) {
          this.agentOptions = res.data.map(function (item) {
            return { id: item.id, label: item.text };
          });
        }
      } catch (e) {
        console.error("loadAgentOptions error:", e);
      }
    },

    async loadDashboardData() {
      try {
        // ถ้ายังไม่เลือก agent → แสดงกราฟโล่ง
        if (!this.selectedAgents || this.selectedAgents.length === 0) {
          this.dashboardData = [];
          this.$nextTick(function () { this.renderCharts(); }.bind(this));
          return;
        }
        var params = { Year: this.selectedYear, Month: this.selectedMonth };
        if (this.selectedAgents && this.selectedAgents.length > 0) {
          params.AgentCodeSap = this.selectedAgents;
        }
        var res = await axios.post("/Api/AgentScore/AgentScoreDashboard", params);
        var apiData = (res.data && Array.isArray(res.data)) ? res.data : [];

        // เติม agent ที่เลือกแต่ไม่มีข้อมูลจาก API ให้แสดงเป็น 0
        if (this.selectedAgents && this.selectedAgents.length > 0) {
          var existingCodes = apiData.map(function (d) { return d.agentCode; });
          var self = this;
          this.selectedAgents.forEach(function (code) {
            if (existingCodes.indexOf(code) === -1) {
              var opt = self.agentOptions.find(function (o) { return o.id === code; });
              var agentName = opt ? opt.label.replace(code + " - ", "") : "";
              apiData.push({
                agentCode: code,
                agentName: agentName,
                syS_JAN: null, syS_FEB: null, syS_MAR: null, syS_APR: null,
                syS_MAY: null, syS_JUN: null, syS_JUL: null, syS_AUG: null,
                syS_SEP: null, syS_OCT: null, syS_NOV: null, syS_DEC: null,
                maC_JAN: null, maC_FEB: null, maC_MAR: null, maC_APR: null,
                maC_MAY: null, maC_JUN: null, maC_JUL: null, maC_AUG: null,
                maC_SEP: null, maC_OCT: null, maC_NOV: null, maC_DEC: null,
              });
            }
          });
        }

        this.dashboardData = apiData;
        this.$nextTick(function () { this.renderCharts(); }.bind(this));
      } catch (e) {
        console.error("loadDashboardData error:", e);
      }
    },

    extractSysScores(item) {
      return [
        item.syS_JAN, item.syS_FEB, item.syS_MAR, item.syS_APR,
        item.syS_MAY, item.syS_JUN, item.syS_JUL, item.syS_AUG,
        item.syS_SEP, item.syS_OCT, item.syS_NOV, item.syS_DEC,
      ];
    },

    extractMacScores(item) {
      return [
        item.maC_JAN, item.maC_FEB, item.maC_MAR, item.maC_APR,
        item.maC_MAY, item.maC_JUN, item.maC_JUL, item.maC_AUG,
        item.maC_SEP, item.maC_OCT, item.maC_NOV, item.maC_DEC,
      ];
    },

    getAgentScores(agent, type) {
      if (agent._empty) return [null, null, null, null, null, null, null, null, null, null, null, null];
      var scores = type === "SYS" ? this.extractSysScores(agent) : this.extractMacScores(agent);
      var maxMonth = this.selectedMonth;
      return scores.map(function (s, i) { return i < maxMonth ? s : null; });
    },

    getScoreBoxValue(agent, type) {
      if (agent._empty) return "-";
      var scores = this.getAgentScores(agent, type);
      for (var i = scores.length - 1; i >= 0; i--) {
        if (scores[i] !== null && scores[i] !== undefined) return scores[i];
      }
      return "-";
    },

    extractSysRemarks(item) {
      return [
        item.syS_JAN_Remark, item.syS_FEB_Remark, item.syS_MAR_Remark, item.syS_APR_Remark,
        item.syS_MAY_Remark, item.syS_JUN_Remark, item.syS_JUL_Remark, item.syS_AUG_Remark,
        item.syS_SEP_Remark, item.syS_OCT_Remark, item.syS_NOV_Remark, item.syS_DEC_Remark,
      ];
    },

    extractMacRemarks(item) {
      return [
        item.maC_JAN_Remark, item.maC_FEB_Remark, item.maC_MAR_Remark, item.maC_APR_Remark,
        item.maC_MAY_Remark, item.maC_JUN_Remark, item.maC_JUL_Remark, item.maC_AUG_Remark,
        item.maC_SEP_Remark, item.maC_OCT_Remark, item.maC_NOV_Remark, item.maC_DEC_Remark,
      ];
    },

    getAgentRemarks(agent, type) {
      if (agent._empty) return [null, null, null, null, null, null, null, null, null, null, null, null];
      var remarks = type === "SYS" ? this.extractSysRemarks(agent) : this.extractMacRemarks(agent);
      var maxMonth = this.selectedMonth;
      return remarks.map(function (r, i) { return i < maxMonth ? (r || null) : null; });
    },

    hasRemarks(agent, type) {
      if (agent._empty) return false;
      var remarks = this.getAgentRemarks(agent, type);
      return remarks.some(function (r) { return r !== null; });
    },

    openRemarkModal(agent, type, monthIdx) {
      var remarks = this.getAgentRemarks(agent, type);
      this.remarkModal = {
        monthName: this.monthsTH_Full[monthIdx] + " " + this.selectedYear,
        text: remarks[monthIdx] || "",
      };
      $("#remarkModal").modal("show");
    },

    getAgentLabel(agent) {
      if (agent._empty) return "";
      return (agent.agentCode || "") + " " + (agent.agentName || "");
    },

    destroyCharts() {
      for (var i = 0; i < this.chartInstances.length; i++) {
        if (this.chartInstances[i].recording) this.chartInstances[i].recording.destroy();
        if (this.chartInstances[i].keg) this.chartInstances[i].keg.destroy();
      }
      this.chartInstances = [];
    },

    renderCharts() {
      this.destroyCharts();

      Chart.defaults.global.defaultFontFamily = "'Noto Sans Thai UI', sans-serif";

      var self = this;
      var agents = this.chartAgents;

      var chartOptions = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            ticks: { min: 0, max: 50, stepSize: 10 },
          }],
        },
        legend: { display: false },
        animation: {
          onComplete: function () {
            var ctx = this.chart.ctx;
            ctx.font = "bold 11px Noto Sans Thai UI";
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";
            this.data.datasets.forEach(function (dataset) {
              var meta = dataset._meta[Object.keys(dataset._meta)[0]];
              meta.data.forEach(function (element, index) {
                var value = dataset.data[index];
                if (value !== null && value !== undefined) {
                  ctx.fillStyle = value >= 40 ? "#0abb87" : "#fd397a";
                  ctx.fillText(value, element._model.x, element._model.y - 6);
                }
              });
            });
          },
        },
      };

      for (var i = 0; i < agents.length; i++) {
        var agent = agents[i];
        var kegCanvas = document.getElementById("kegChart-" + i);
        var recordingCanvas = document.getElementById("recordingChart-" + i);
        if (!kegCanvas || !recordingCanvas) continue;

        var macScores = self.getAgentScores(agent, "MAC");
        var sysScores = self.getAgentScores(agent, "SYS");

        var kegInstance = new Chart(kegCanvas, {
          type: "line",
          data: {
            labels: self.monthsTH,
            datasets: [{
              label: "คะแนนการบริหารถัง",
              data: macScores,
              borderColor: "#0abb87",
              backgroundColor: "rgba(10, 187, 135, 0.1)",
              borderWidth: 2,
              pointRadius: 4,
              pointBackgroundColor: "#0abb87",
              fill: true,
            }],
          },
          options: chartOptions,
        });

        var recordingInstance = new Chart(recordingCanvas, {
          type: "line",
          data: {
            labels: self.monthsTH,
            datasets: [{
              label: "คะแนนความครบถ้วนของการบันทึกข้อมูล",
              data: sysScores,
              borderColor: "#5867dd",
              backgroundColor: "rgba(88, 103, 221, 0.1)",
              borderWidth: 2,
              pointRadius: 4,
              pointBackgroundColor: "#5867dd",
              fill: true,
            }],
          },
          options: chartOptions,
        });

        self.chartInstances.push({ recording: recordingInstance, keg: kegInstance });
      }
    },
  },
  async mounted() {
    this.checkPermission();

    // Year datepicker (calendar year-only)
    var self = this;
    var arrows = {
      leftArrow: '<i class="la la-angle-left"></i>',
      rightArrow: '<i class="la la-angle-right"></i>',
    };
    $(self.$refs.odYear).datepicker({
      format: "yyyy",
      viewMode: "years",
      minViewMode: "years",
      autoclose: true,
      clearBtn: true,
      orientation: "bottom left",
      templates: arrows,
    }).on("changeDate", function (e) {
      if (e.date) {
        self.selectedYear = e.date.getFullYear();
      }
    });
    $(self.$refs.odYear).datepicker("setDate", new Date(self.selectedYear, 0, 1));

    await this.loadAgentOptions();
    if (this.agentOptions.length > 0) {
      this.selectedAgents = [this.agentOptions[0].id];
    }
    await this.loadDashboardData();
  },
  beforeDestroy() {
    this.destroyCharts();
  },
};
</script>

<style scoped>
.score-box {
  width: 100px;
  height: 100px;
  border: 1px solid #5867dd;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.score-box--green {
  border-color: #cccccc;
}
.score-box--red {
  border-color: #cccccc;
}
.score-value {
  font-size: 3.5rem;
  font-weight: bold;
  font-family: inherit;
}
.info-hint {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-left: 6px;
  background-color: #5d9cec;
  color: #ffffff;
  border-radius: 5px;
  font-size: 0.75rem;
  font-weight: bold;
  font-style: normal;
  font-family: Georgia, 'Times New Roman', serif;
  line-height: 1;
  vertical-align: middle;
  cursor: pointer;
}
/* Custom tooltip — โผล่ทันที (ไม่มี delay), คลิกแล้วไม่หาย, หายเมื่อเลื่อนเมาส์ออก */
.info-hint::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: 260px;
  background-color: #333333;
  color: #ffffff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: normal;
  font-style: normal;
  font-family: inherit;
  line-height: 1.4;
  white-space: normal;
  text-align: left;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
/* ลูกศรชี้ลงใต้กล่อง tooltip */
.info-hint::before {
  content: "";
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #333333;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
.info-hint:hover::after,
.info-hint:hover::before {
  opacity: 1;
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// App/Components/Dashboard/AgentScoreDashboard.vue